// extracted by mini-css-extract-plugin
export default {"content":"LearningPathList_content__UgWAt"};